import * as R from 'ramda'
import {
  all,
  call,
  cancel,
  cancelled,
  fork,
  select,
  put,
  take,
} from 'redux-saga/effects'

import {
  getRequest
} from 'helpers/RequestUtil'

import {
  APP_PAGE_MOUNT,
  APP_PAGE_UNMOUNT,
  TOGGLE_NAVIGATION_DRAWER,
  FETCH_USER_PROFILE,
  FETCH_USER_PROFILE_START,
  FETCH_USER_PROFILE_SUCCESS,
  FETCH_USER_PROFILE_ERROR,
} from './constants'

import {
  fetchUserProfileStart,
  fetchUserProfileSuccess,
  fetchUserProfileError,
} from './actions'

import {
  clearUserId,
  clearUserAttributes,
  updateUserId,
  updateUserProfile
} from 'containers/User/Login/actions'

/**
 * fetchUserProfile
 *
 * get user profile
 *
 * @returns undefined
 */
function* fetchUserProfile() {
  let response, attributes
  try {
    yield put(fetchUserProfileStart())
    response = yield call(getRequest, '/api/fulcrum/profile')
    // make sure to update user profile
    attributes = R.path(['data', 'attributes'], response)
    if (attributes === undefined)
      throw 'Unable to retrieve user profile'
    yield put(updateUserProfile(attributes))
    yield put(fetchUserProfileSuccess(attributes))
  } catch(error) {
    yield put(fetchUserProfileError(error))
  } finally {
    if (yield cancelled()) {
      yield put(clearUserAttributes())
    }
  }

  return R.path(['data', 'id'], response)
}

function* appMountHandler() {
  try {
    const userId = yield call(fetchUserProfile)
    if (userId)
      yield put(updateUserId(userId))
  } finally {
    if (yield cancelled()) {
      yield put(clearUserId())
    }
  }
}

function* appUnmountHandler() {
  yield
}

function* watchLoadApp() {
  let task

  while(true) {
    if (task) yield cancel(task)

    yield take(APP_PAGE_MOUNT)
    task = yield fork(appMountHandler)
    yield take(APP_PAGE_UNMOUNT)
    yield cancel(task)
    task = yield fork(appUnmountHandler)
  }
}

function* loadSagas() {
  yield all([
    fork(watchLoadApp)
  ])
}

export default loadSagas
